import React from "react";
import { connect } from "react-redux";
//import {modelsFromObject} from '../helpers/models-from-object.js'
import { sendReadyToFirebase } from "./connection/firebase-send-ready.js";
import { setMatchmakingValue } from "../redux-actions/battle-actions.js";
import { buildTeamsFromClientBuddies } from "./lifecycle/build-teams-from-client-buddies.js";
import CrewLineup from "../b5-home/CrewLineup.js";
import LobbyCTA from "../b5-home/LobbyCTA.js";
import MenuHeader from "../b5-home/MenuHeader.js";
import FullteamInviteModal from "../b5-home/FullteamInviteModal.js";
import EditCrewNameModal from '../b5-home/EditCrewNameModal'
import MenuHeaderInviteLink from '../b5-home/MenuHeaderInviteLink'
import AudioControl from '../_audio/AudioControl'
import audioManager from '../_audio/audio-manager'

class FullteamBattleLobby extends React.Component {

  componentDidMount() {
    //Play the music!
    audioManager.playSong("music_b5Menu");
  }

  handleStartButtonClick() {
    //masterStartBattle();
    sendReadyToFirebase(() => {
      //console.log('ready!')
      //TODO: if you want to fancy up the interaction, you have this callback.
    });
  }

  handleCloseInviteLinkModal() {
    setMatchmakingValue({
      isLobbyInviteModalOpen: false
    });
  }

  //Maybe return styles that wrap the desktop layout together
  getDesktopWrap() {
    if (this.props.viewportMode === "portrait") {
      return {};
    }
    return {
      width: "45em",
      margin: "0 auto"
    };
  }

  /** Cross reference roomCrewNames with our enemyTeamObject to get a Crew Name */
  getEnemyCrewName(enemyTeamObject) {
    //Filter for keys that are in both
    const enemyKeysWithCrewNames = Object.keys(enemyTeamObject).filter(key => {
      return Boolean(this.props.roomCrewNames[key]);
    });

    //Return the first match
    if (enemyKeysWithCrewNames.length > 0) {
      return this.props.roomCrewNames[enemyKeysWithCrewNames[0]];
    }

    return ""; //Known crew name
  }

  renderInviteLinkModal() {
    if (this.props.isLobbyInviteModalOpen) {
      return (
        <FullteamInviteModal
          handleCloseCallback={this.handleCloseInviteLinkModal.bind(this)}
        />
      );
    }
    return null;
  }

  /* Show Crew Name modal if we're editing Crew Name */
  renderEditCrewNameModal() {
    if (this.props.isCrewNameModalOption) {
      return <EditCrewNameModal />;
    }
    return null;
  }

  renderMasterUi() {
    const isReady = this.props.roomReadyClients[this.props.logggedInUserId];

    if (isReady) {
      return (
        <LobbyCTA
          text="Ready!"
          isDisabled={true}
          isReadyPressed={true}
          handler={function() {}}
        />
      );
    }
    return (
      <LobbyCTA
        text="Ready to Battle"
        isDisabled={false}
        handler={this.handleStartButtonClick.bind(this)}
      />
    );

    //return <div>Waiting for Master to start match</div>
  }

  renderOpponentTeam(enemyTeamObject) {
    //If we have a populated object, return the opponent Lineup as usual
    if (Object.keys(enemyTeamObject).length > 0) {
      const enemyClientId = Object.keys(enemyTeamObject)
        .find(key => key.match(/^client_/))
        .replace("client_", "");
      const isEnemyTeamReady = this.props.roomReadyClients[enemyClientId];

      const readyIndicatorStyle = {
        position: "absolute",
        left: "50%",
        top: "8em",
        transform: "translateX(-50%)",
        background: "#46D47E",
        border: "0.2em solid #fff",
        color: "#fff",
        width: "13em",
        padding: "0.7em",
        textAlign: "center",
        display: isEnemyTeamReady ? "block" : "none"
      };

      return (
        <div>
          <CrewLineup
            showLaptop={true}
            crewTeamModel={enemyTeamObject}
            areCombatantsEditable={false}
            crewName={this.getEnemyCrewName(enemyTeamObject)}
          />
          <div style={readyIndicatorStyle}>Ready!</div>
        </div>
      );
    }
    //Otherwise, return a mystery man team!
    const mysteryManShadowTeam = {
      shadowPersonOne: { skinId: "skin_mystery", arenaPosition: 1 },
      shadowPersonTwo: { skinId: "skin_mystery", arenaPosition: 2 },
      shadowPersonThree: { skinId: "skin_mystery", arenaPosition: 3 }
    };
    const containerStyle = { position: "relative" };
    const messageStyle = {
      position: "absolute",
      left: "50%",
      top: "8em",
      transform: "translateX(-50%)",
      background: "#170226",
      border: "0.2em solid #fff",
      color: "#fff",
      // width: "17em",
      lineHeight: "1.7em",
      padding: "1.4em 2em",
      textAlign: "center",
      fontSize: "0.8em"
    };
    const inviteLinkStyle = {
      display: "block",
      paddingTop: "1em",
      color: "#6cb0ff"
    };
    return (
      <div style={containerStyle}>
        <CrewLineup
          showLaptop={false}
          crewTeamModel={mysteryManShadowTeam}
          areCombatantsEditable={false}
          crewName=""
        />
        <div style={messageStyle}>
          Waiting for Opponent
          <div>
            <MenuHeaderInviteLink
              text="Invite somebody"
              customStyle={inviteLinkStyle}
            />
          </div>
        </div>
      </div>
    );
  }

  renderCombatantGroups() {
    //Only for UI layout. Does not affect actual teams
    const teams = buildTeamsFromClientBuddies(this.props.initialCombatantData);

    let teamOneCombatantsObject = {};
    teams.one.combatantIds.forEach(id => {
      teamOneCombatantsObject[id] = { ...this.props.initialCombatantData[id] };
    });

    let teamTwoCombatantsObject = {};
    teams.two.combatantIds.forEach(id => {
      teamTwoCombatantsObject[id] = { ...this.props.initialCombatantData[id] };
    });

    const playerMainId = this.props.battlePlayerId[0];
    let playerTeamId = null;
    if (teams.one.combatantIds.includes(playerMainId)) {
      playerTeamId = "one";
    }
    if (teams.two.combatantIds.includes(playerMainId)) {
      playerTeamId = "two";
    }

    if (!playerTeamId) {
      return null;
    }

    const playerTeamObject =
      playerTeamId === "one"
        ? teamOneCombatantsObject
        : teamTwoCombatantsObject;
    const enemyTeamObject =
      playerTeamId === "one"
        ? teamTwoCombatantsObject
        : teamOneCombatantsObject;

    //Need to show Player's team from crew state. Use the PlayerTeamObject to create a version that looks up members
    //from crew state. This allows them to instantly update on edits and not wait for Firebase response.
    //In other words: Enemy team is data from Firebase's initialCombatantData. Friendly team is from local state.
    let playerTeamObjectFromCrewState = {};
    Object.keys(playerTeamObject).forEach(key => {
      const modelFromPlayerTeamObject = playerTeamObject[key];
      playerTeamObjectFromCrewState[modelFromPlayerTeamObject.memberId] = {
        ...this.props.crewMembers[modelFromPlayerTeamObject.memberId]
      };
    });

    return (
      <div>
        {this.renderOpponentTeam(enemyTeamObject)}

        <CrewLineup
          showLaptop={true}
          crewTeamModel={playerTeamObjectFromCrewState}
          areCombatantsEditable={true}
          crewName={this.props.crewName}
        />
      </div>
    );
  }

  render() {
    if (!this.props.initialCombatantData) {
      console.warn(
        "this.props.initialCombatantData is undefined in FullteamBattleLobby. Shouldnt be mounted"
      );
    }
    const { vW, viewportMode } = this.props;

    const style = {
      fontSize: viewportMode === "portrait" ? "0.6em" : "0.45em", //mobile, desktop
      height: "100%"
    };

    const contentContainerStyle = {
      width: viewportMode === "portrait" ? "100%" : vW * 40,
      position: "relative",
      height: "100%",
      margin: "0 auto"
    };

    //TODO: Can this cancel link be js-only? It would be cool to avoid another page load, but would need to clear out of a bunch of stuff
    return (
      <div style={{ height: "100%" }}>
        <div style={style} className="page-container menu-texture">
          {/*Top, header container*/}
          {/*<div className="page-container--section">*/}
            <MenuHeader />
            <AudioControl />
          {/*</div>*/}

          {/* Middle section */}
          <div
            className="page-container--section"
            style={this.getDesktopWrap()}
          >
            <div style={contentContainerStyle}>
              {this.renderCombatantGroups()}
            </div>
          </div>

          {/* Bottom CTA container */}
          <div
            className="page-container--section"
            style={{ padding: "2em 2em 3em", ...this.getDesktopWrap() }}
          >
            {this.renderMasterUi()}
          </div>
        </div>

        {this.renderEditCrewNameModal()}
        {this.renderInviteLinkModal()}

      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    vW: state.global.vW,
    viewportMode: state.global.viewportMode,

    currentRoomId: state.matchmaking.currentRoomId,
    initialCombatantData: state.matchmaking.initialCombatantData,
    roomCrewNames: state.matchmaking.crewNames, //known crewNames in the room
    roomReadyClients: state.matchmaking.readyClients, //know who's ready in the room

    isLobbyInviteModalOpen: state.matchmaking.isLobbyInviteModalOpen,
    isCrewNameModalOption: state.matchmaking.isCrewNameModalOption,

    isMultiplayerMasterClient: state.battle.isMultiplayerMasterClient,

    battlePlayerId: state.battle.battlePlayerId,

    crewName: state.crew.name,
    crewMembers: state.crew.members,
    logggedInUserId: state.crew.logggedInUserId
  };
})(FullteamBattleLobby);



// WEBPACK FOOTER //
// ./src/battle/FullteamBattleLobby.js